import React from 'react';
import { BlockCard, PageBody, PageContainer, PageHeader } from '../../components/container';
import { ArrowUpRight, Database, FileText, RefreshCw } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';

const Dashboard = () => {
	return (
		<PageContainer>
			<PageHeader 
				title="Dashboard" 
				description="Toàn cảnh hiệu suất nội dung, sản phẩm và luồng vận hành trong ngày"
				action={
					<div className='flex items-center gap-2'>
						<Button variant='outline' className='h-9'>Xuất báo cáo ngày</Button>
						<Button className='h-9 gap-1.5'>
							Đi tới xử lý nhanh
							<ArrowUpRight className='h-4 w-4' />
						</Button>
					</div>
				}
			/>
			<PageBody>
				<div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
					<BlockCard className='xl:col-span-4' contentClassName='!p-0'>
						<div className='grid grid-cols-1 gap-3 p-4 md:grid-cols-3 md:p-5'>
							{['Sản phẩm', 'Tin bài', 'Tương tác'].map((label) => (
								<div key={label} className='rounded-2xl border border-border/60 bg-background/70 p-4'>
									<div className='mb-3 flex items-start justify-between gap-2'>
										<div>
											<p className='text-xs uppercase tracking-wide text-muted-foreground'>{label}</p>
											<p className='mt-1 text-3xl font-bold leading-none'>--</p>
										</div>
										<div className='rounded-xl bg-muted/60 p-2.5'>
											<Database className='h-5 w-5 text-muted-foreground' />
										</div>
									</div>
									<div className='flex items-center justify-between'>
										<Badge variant='outline'>Đang đồng bộ</Badge>
										<p className='text-xs text-muted-foreground'>Chưa có dữ liệu production</p>
									</div>
								</div>
							))}
						</div>
					</BlockCard>

					<BlockCard title='Tác vụ trọng tâm hôm nay' description='Các điểm cần ưu tiên xử lý theo SLA nội bộ'>
						<div className='space-y-3'>
							<div className='rounded-xl border border-border/70 bg-muted/25 p-3'>
								<p className='text-sm font-semibold'>09 bài viết đang chờ biên tập</p>
								<p className='text-xs text-muted-foreground'>Nên xử lý trong 4 giờ tới</p>
							</div>
							<div className='rounded-xl border border-border/70 bg-muted/25 p-3'>
								<p className='text-sm font-semibold'>06 sản phẩm thiếu ảnh chuẩn SEO</p>
								<p className='text-xs text-muted-foreground'>Tác động trực tiếp đến trang danh mục</p>
							</div>
						</div>
					</BlockCard>

					<BlockCard title='Dòng sự kiện gần nhất' description='Luồng thay đổi theo thời gian thực'>
						<div className='rounded-xl border border-dashed border-border/70 bg-muted/20 p-4 text-sm text-muted-foreground'>
							<p>Feed realtime chưa được cấu hình ở môi trường hiện tại.</p>
							<p className='mt-1'>Kết nối endpoint log hoạt động để hiển thị dữ liệu thật theo thời gian.</p>
						</div>
					</BlockCard>

					<BlockCard 
						title="Trạng thái hệ thống"
						description="Bảng điều khiển production không hiển thị dữ liệu mẫu"
					>
						<div className='space-y-3'>
							<p className='text-sm text-muted-foreground'>Dữ liệu thống kê sẽ xuất hiện khi API dashboard được bật.</p>
							<Button variant='outline' className='h-9 gap-2'>
								<RefreshCw className='h-4 w-4' />
								Làm mới dữ liệu
							</Button>
						</div>
					</BlockCard>
				</div>
			</PageBody>
		</PageContainer>
	);
};

export default Dashboard;
